<template>
  <div class="lottie-bg">
    <div id="lottie">
      <img
        src="@assets/images/live-logo.gif"
        rel="preload"
        style="width: 100%;"
      />
    </div>
  </div>
</template>

<script>
import { auth } from "@libs/wechat";

function getBackUrl(route) {
  try {
    const raw = route.params.url || encodeURIComponent("/");
    let url = decodeURIComponent(decodeURIComponent(raw));
    if (!url || url === "undefined" || url === "null") {
      url = "/";
    }
    if (url.indexOf("/") !== 0) {
      url = "/" + url.replace(/^\/+/, "");
    }
    return url;
  } catch (e) {
    return "/";
  }
}

export default {
  name: "Loading",
  mounted() {
    const { code } = this.$route.query;
    if (!code) {
      location.replace("/");
      return;
    }
    auth(code)
      .then(() => {
        setTimeout(() => {
          location.replace(getBackUrl(this.$route));
        }, 200);
      })
      .catch(err => {
        console.error("微信授权失败", err);
        alert((err && err.msg) || "微信授权失败，请关闭页面后重新进入");
      });
  }
};
</script>

<style scoped>
.lottie-bg {
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

#lottie {
  width: 35%;
  display: block;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  margin: auto;
}
</style>
